export const Flag = ({
  color,
}: {
  width?: string
  height?: string
  color: string
}) => (
  <svg
    version="1.1"
    viewBox="0 0 25 28"
    width="25px"
    height="28px"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="m21.947 2.49h-19.851v-1.49c0-0.54999-0.4715-1-1.0477-1-0.58674 0-1.0477 0.45001-1.0477 1v26c0 0.54999 0.46101 1 1.0477 1 0.57625 0 1.0477-0.45001 1.0477-1v-11.85h19.851c0.39814 0 0.7649-0.20996 0.94299-0.54999 0.1781-0.33002 0.13621-0.73999-0.094329-1.04l-3.6985-4.74 3.6985-4.74c0.23054-0.29999 0.27242-0.69995 0.094329-1.04-0.1781-0.33996-0.54485-0.54998-0.94299-0.54998z"
      fill="currentColor"
    />
    <path
      d="m6.985 6.65c0.433 0 0.815 0.083 1.145 0.25s0.588 0.42 0.775 0.76 0.28 0.77 0.28 1.29v3.05h-0.96v-2.94c0-0.513-0.125-0.9-0.375-1.16s-0.602-0.39-1.055-0.39c-0.34 0-0.637 0.067-0.89 0.2s-0.448 0.33-0.585 0.59-0.205 0.583-0.205 0.97v2.73h-0.96v-5.3h0.92v1.43l-0.15-0.38c0.173-0.347 0.44-0.617 0.8-0.81s0.78-0.29 1.26-0.29zm3.635 3.02v-0.83h2.69v0.83h-2.69zm4.739 2.33v-6.6l0.43 0.47h-2.01v-0.87h2.57v7h-0.99z"
      fill="#fff"
    />
  </svg>
)
